/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import supplierService from './../../../../services/supplier';
import countryService from './../../../../services/country';
import postalService from './../../../../services/postal';
import supplierTransformer from './../../../../transformers/supplier';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        code: {
          value: '',
          type: 'text',
        },
        name: {
          value: '',
          type: 'text',
        },
      }),
      formContactInformation: new Forms({
        email: {
          value: '',
          type: 'text',
        },
        phonenumber: {
          value: '',
          type: 'text',
        },
        mobilenumber: {
          value: '',
          type: 'text',
        },
      }),
      formAddressInformation: new Forms({
        streetName1: {
          value: '',
          type: 'text',
        },
        streetName2: {
          value: '',
          type: 'text',
        },
        postalCode: {
          value: '',
          type: 'text',
        },
        city: {
          value: '',
          type: 'text',
        },
        countryId: {
          value: 1,
          type: 'select',
        },
      }),

      loading: true,
      tabIndex: 'first',
    };
  },

  computed: {
    ...mapGetters({
      countries: 'allCountries',
      municipalities: 'allMunicipalities',
      postals: 'allPostals',
    }),
  },

  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} countries    The countries list.
     */
    countries(countries) {
      this.formAddressInformation.setOptions('countryId', countries.items);
    },
  },

  created() {
    this.loading = true;
    Promise.all([
      countryService.all(),
    ]).then(() => {
      this.loading = false;
      this.formBasicInformation.disableField('code');
    });
  },

  methods: {
    /**
     * Method to store the client
     */
    store() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = supplierTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), this.formContactInformation.data(), this.formAddressInformation.data())
      );
      supplierService.store(client)
      .then(() => {
        this.$message({
          message: this.$t('static.supplier.create.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'supplier.index',
        });
      }).catch((errors) => {
        this.formBasicInformation.loading = false;
        this.formAddressInformation.recordErrors(errors);
        this.formContactInformation.recordErrors(errors);
        this.formBasicInformation.recordErrors(errors);

        if (this.formBasicInformation.errors.any()) {
          this.tabIndex = 'first';
        } else if (this.formAddressInformation.errors.any()) {
          this.tabIndex = 'third';
        } else if (this.formContactInformation.errors.any()) {
          this.tabIndex = 'second';
        }
      });
    },

    /**
     * Method to display the city
     */
    showCityByPostalCode(postalCode) {
      if (this.postals.items.length > 0) {
        const postal = this.postals.items.filter(p => (
          postalCode === p.postalCode.toString()
        ))[0];

        this.formOtherInformation.cityName = postal.cityName;
      }
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/supplier/create/create.js